Jelly.Actions.Add_Member = function(Parameters) {
	var $Table_Wrapper = $("#" + Parameters.Namespace.Action + "_" + Parameters.Namespace.Membership + "_Add_Member_Table_Wrapper");
	var $Table = $Table_Wrapper.find("table");
	var $Body = $Table.find("tbody");
	var Include_Phone = Parameters.Include_Phone === true;
	var Member_Count = $Table.find("tbody tr").length + 1;

	if (!$Body.length) {
		$Body = $("<tbody/>").appendTo($Table);
	}

	var $Row = $("<tr/>");
	$Row.append($("<td/>").text(Parameters.Member.Name));
	$Row.append($("<td/>").text(Parameters.Member.Email));
	if (Include_Phone) {
		$Row.append($("<td/>").text(Parameters.Member.Phone || ""));
	}
	$Row.append($("<td/>").text(Parameters.Member.Until));
	$Body.append($Row);
	$Table_Wrapper.show();

	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters.Namespace.Action,
		Input_Alias: Parameters.Namespace.Membership + "_Add_Member_Count",
		Value: Member_Count
	});
	["Name", "First_Name", "Last_Name", "Email", "Until"].forEach(function(Field) {
		Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action,
			Input_Alias: Parameters.Namespace.Membership + "_Add_Member_" + Member_Count + "_" + Field,
			Value: Parameters.Member[Field] || ""
		});
	});
	if (Include_Phone) {
		Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action,
			Input_Alias: Parameters.Namespace.Membership + "_Add_Member_" + Member_Count + "_Phone",
			Value: Parameters.Member.Phone || ""
		});
	}
	if (Parameters.Namespace.Membership_Id) {
		Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action,
			Input_Alias: Parameters.Namespace.Membership + "_Add_Member_" + Member_Count + "_Target_Membership_ID",
			Value: Parameters.Namespace.Membership_Id
		});
	}
};

Jelly.Actions.Add_Members = function(Parameters) {
	if (!Array.isArray(Parameters.Members) || !Parameters.Members.length) {
		throw new Error("The file does not contain any member rows.");
	}

	var normalizeHeader = function(Value) {
		return String(Value == null ? "" : Value).trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
	};
	var toString = function(Value) {
		return String(Value == null ? "" : Value).trim();
	};
	var normalizeName = function(Record) {
		Record.Name = toString(Record.Name);
		Record.First_Name = toString(Record.First_Name);
		Record.Last_Name = toString(Record.Last_Name);
		if (!Record.Name) {
			Record.Name = [Record.First_Name, Record.Last_Name].filter(Boolean).join(" ");
		}
		return Record;
	};
	var Members = Parameters.Members;
	var Records = [];

	if (Array.isArray(Members[0])) {
		var Header = Members[0].map(normalizeHeader);
		var Header_Count = Header.length;
		var findColumn = function(Aliases) {
			return Header.findIndex(function(Value) { return Aliases.indexOf(Value) !== -1; });
		};
		var Columns = {
			Name: findColumn(["name", "fullname", "membername"]),
			First_Name: findColumn(["first", "firstname", "givenname"]),
			Last_Name: findColumn(["last", "lastname", "surname", "familyname"]),
			Email: findColumn(["email", "emailaddress"]),
			Until: findColumn(["until", "effectiveuntil", "enddate", "expires"]),
			Phone: findColumn(["phone", "phonenumber", "mobile", "telephone"])
		};
		if ((Columns.Name < 0 && (Columns.First_Name < 0 || Columns.Last_Name < 0)) || Columns.Email < 0 || (Parameters.Include_Phone && Columns.Phone < 0)) {
			throw new Error("Map the required member columns before importing.");
		}
		Members.slice(1).forEach(function(Row, Index) {
			if (!Array.isArray(Row) || Row.length !== Header_Count) {
				throw new Error("Row " + (Index + 2) + " has a different number of columns than the header. Fix that row and upload the file again.");
			}
			Records.push(normalizeName({
				Name: Columns.Name < 0 ? "" : toString(Row[Columns.Name]),
				First_Name: Columns.First_Name < 0 ? "" : toString(Row[Columns.First_Name]),
				Last_Name: Columns.Last_Name < 0 ? "" : toString(Row[Columns.Last_Name]),
				Email: toString(Row[Columns.Email]),
				Until: Columns.Until < 0 ? "" : toString(Row[Columns.Until]),
				Phone: Columns.Phone < 0 ? "" : toString(Row[Columns.Phone])
			}));
		});
	}
	else {
		Records = Members.map(function(Member) {
			return normalizeName({
				Name: toString(Member.Name),
				First_Name: toString(Member.First_Name),
				Last_Name: toString(Member.Last_Name),
				Email: toString(Member.Email),
				Until: toString(Member.Until),
				Phone: toString(Member.Phone)
			});
		});
	}

	var Seen_Emails = {};
	Records.forEach(function(Member, Index) {
		var Validation_Error = ((Member.First_Name && !Member.Last_Name) || (!Member.First_Name && Member.Last_Name)) ?
			"Map both First name and Last name, or use Full name." : Jelly.Actions.Validate_Member({
			Name: Member.Name,
			Email: Member.Email,
			Phone: Member.Phone,
			Until: Member.Until,
			Namespace: Parameters.Namespace,
			Skip_Table_Duplicate_Check: true
		});
		var Normalized_Email = Member.Email.toLowerCase();
		if (!Validation_Error && Seen_Emails[Normalized_Email]) {
			Validation_Error = "This email address appears twice in this file. Please use one row per person.";
		}
		if (Validation_Error) {
			throw new Error("Row " + (Index + 2) + ": " + Validation_Error + " No members were added.");
		}
		Seen_Emails[Normalized_Email] = true;
	});

	Jelly.Actions.Clear_Members(Parameters);

	Records.forEach(function(Member) {
		Jelly.Actions.Add_Member({
			Namespace: Parameters.Namespace,
			Include_Phone: Parameters.Include_Phone === true,
			Member: Member
		});
	});
};

Jelly.Actions.Clear_Members = function(Parameters) {
	var Prefix = Parameters.Namespace.Membership + "_Add_Member_";
	var $Action = $("#" + Parameters.Namespace.Action);
	var Count_Alias = Parameters.Namespace.Membership + "_Add_Member_Count";
	var Action_Element = $Action.get(0);
	var Action_Reference = Action_Element ? Jelly.References.Get_Reference_For_Element(Action_Element) : null;
	if (Action_Reference && Action_Reference.Inputs) {
		Object.keys(Action_Reference.Inputs).forEach(function(Input_Alias) {
			if (Input_Alias.indexOf(Prefix) === 0 || Input_Alias === Count_Alias) {
				Jelly.Actions.Remove_Action_Input({
					Namespace: Parameters.Namespace.Action,
					Alias: Input_Alias,
					Element: Action_Reference.Inputs[Input_Alias].Element
				});
			}
		});
	}
	// Remove any matching orphan inputs that predate action-input registration.
	$Action.find("input").filter(function() {
		return (this.name || "").indexOf(Prefix) === 0 || (this.name || "") === Count_Alias;
	}).remove();
	var $Table_Wrapper = $("#" + Parameters.Namespace.Action + "_" + Parameters.Namespace.Membership + "_Add_Member_Table_Wrapper");
	$Table_Wrapper.find("tbody").remove();
	$Table_Wrapper.hide();
};
